import { Box, Text, Card, Flex, Button, Badge, AlertDialog, DropdownMenu, VisuallyHidden, IconButton, Dialog, HoverCard } from '@radix-ui/themes';
import { ExclamationTriangleIcon, Cross2Icon, PlusIcon } from '@radix-ui/react-icons';
import { useState, useEffect } from 'react';
import { periodService } from '../../services/teacher/periodService';
import LoadingIndicator from '../shared/LoadingIndicator';
import CreatePeriod from '../forms/teacher/CreatePeriod';
import CreateTeachingPlan from '../forms/teacher/CreateTeachingPlan';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { updateTeacherTeachingPlans, updateTeacherPeriods, updateTeacherCourses } from '../../redux/slices/teacherAccountSlice';
import ViewPeriod from '../forms/teacher/ViewPeriod';
import { STATUS_COLORS } from '../../utils/constants';
import { teachingPlanService } from '../../services/teacher/teachingPlanService';
import { create, set } from 'lodash';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const TeacherPeriods = () => {
    const [loading, setLoading] = useState(false);
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const [showPeriodDialog, setShowPeriodDialog] = useState(false);
    const [selectedPeriod, setSelectedPeriod] = useState(null);

    const [createTeachingPlan, setCreateTeachingPlan] = useState({
        creating: false,
        period: null,
        course: null,
    });

    const periods = useSelector(state => state.teacherAccount.periods);
    // const teachingPlans = useSelector(state => state.teacherAccount.teachingPlans);
    const courses = useSelector(state => state.teacherAccount.courses);

    console.log('courses test', courses);
    const dispatch = useDispatch();

    const handlePeriodCreated = (period) => {
        console.log('handlePeriodCreated', period);
        dispatch(updateTeacherPeriods(period));
        setShowCreateDialog(false);
        // setSelectedPeriod(period);
    };

    const handleAddTeachingPlan = async (period, course) => {
        setCreateTeachingPlan({
            creating: true,
            period: period,
            course: course,
        });
    };



    // const handleFinalizePeriod = () => {
    //     console.log('handleFinalizePeriod', selectedPeriod);
    // }

    // const finalizePeriod = async (period) => {
    //     try {
    //         const response = await periodService.finalizePeriod(period.id);
    //     } catch (error) {
    //         toast.error('Error finalizing period');
    //     }
    // }

    const renderStatus = (period) => {
        if (period.status === 'completed' || period.status === 'suspended') {
            return <Badge size="1" variant="solid" color="gray">{period.status}</Badge>;
        }

        if (period.status === 'active') {
            const endDate = DateTime.fromISO(period.end_date);
            const now = DateTime.now();
            if (now.diff(endDate, 'days').days > 2) {
                return <Badge variant="solid" size="1" color="amber"><ExclamationTriangleIcon /> Finalize</Badge>;
            }
            return <Badge variant="solid" size="1" color={STATUS_COLORS['active']}>active</Badge>;
        }
        return null;
    }

    // const handleFinalizePeriod = () => {
    //     console.log('handleFinalizePeriod', selectedPeriod);
    // }

    // const finalizePeriod = async (period) => {
    //     try {
    //         const response = await periodService.finalizePeriod(period.id);
    //     } catch (error) {
    //         toast.error('Error finalizing period');
    //     }
    // }

    const renderPeriod = (period) => {
        const planned_courses = courses.filter(course => course.active_teaching_plan?.period_id === period.id) || [];
        const unplanned_courses = courses.filter(course => course.active_teaching_plan == null);
        const status = DateTime.now().toFormat('yyyy-MM-dd') > period.end_date ? 'inactive' : 'active';

        return (
            <Box key={period.id} pb="4" width="100%" style={{ borderTop: '1px solid var(--gray-6)' }}>
                <Flex justify="between" align="center" gap="2" width="100%" py="2" className="cursor-pointer"
                    onClick={() => {
                        setSelectedPeriod(period);
                        setShowPeriodDialog(true);
                    }}
                >
                    <Text size="2" weight="bold" style={{ color: 'var(--accent-9)' }}>{period.title}</Text>
                    {renderStatus(period)}
                </Flex>

                <Flex direction="row" justify="between" align="start" width="100%" gap="2" pt="2">
                    <Flex gap="2" align="center" style={{ flex: 1, flexWrap: 'wrap' }}>
                        {planned_courses.length > 0 ? (
                            planned_courses.map(course => (
                                <Button key={course.active_teaching_plan.id} size="1" variant="soft" color={STATUS_COLORS[course.active_teaching_plan.status]}>{course.level.label} | {course.subject.label}</Button>
                            ))
                        ) : (
                            <Text size="1" color="accent">No teaching plans assigned</Text>
                        )}
                    </Flex>
                    {period.status !== 'completed' && period.status !== 'suspended' && (
                        unplanned_courses.length > 0 && (
                            <DropdownMenu.Root>
                                <DropdownMenu.Trigger>
                                    <IconButton variant="soft" size="1" >
                                        <PlusIcon />
                                    </IconButton>
                                </DropdownMenu.Trigger>
                                <DropdownMenu.Content>
                                    {unplanned_courses.map(course => (
                                        <DropdownMenu.Item key={`unplanned-course-${course.id}`} onClick={() => handleAddTeachingPlan(period, course)}>
                                            {course.level.label} | {course.subject.label}
                                        </DropdownMenu.Item>
                                    ))}
                                </DropdownMenu.Content>
                            </DropdownMenu.Root>)
                    )}
                </Flex>

            </Box>
        )
    };

    if (loading) {
        return <LoadingIndicator />
    }

    return (
        <Box width="100%">
            <Flex direction="column" align="start" justify="start" style={{ height: '100%' }}>
                <Flex direction="row" justify="between" align="center" gap="2" width="100%" mb="4">
                    <Text size="3" weight="bold">Periods (Terms)</Text>
                    <Flex gap="2" align="center">
                        <HoverCard.Root>
                            <HoverCard.Trigger>
                                <QuestionMarkCircleIcon width="20" height="20" color="var(--gray-8)" />
                            </HoverCard.Trigger>
                            <HoverCard.Content size="1" maxWidth="240px">
                                <Text size="1" weight="bold" mb="1" as="p">Periods</Text>
                                <Text as="p" size="1">A period is when your class starts and ends. You can add your teaching plans to periods</Text>
                                <Text as="p" size="1">You can have different active periods but a course can only have one active period</Text>
                            </HoverCard.Content>
                        </HoverCard.Root>
                        {periods.filter(period => period.status === 'active').length < 2 && (
                            <IconButton size="1" variant="soft" onClick={() => setShowCreateDialog(true)}><PlusIcon /></IconButton>
                        )}

                    </Flex>
                </Flex>
                {periods.filter(period => period.status === 'active').length > 0 && periods.filter(period => period.status === 'active').map(period => (
                    <Box key={period.id} width="100%">
                        {renderPeriod(period)}
                    </Box>
                ))}
                {periods.filter(period => period.status === 'active').length < 2 && (
                    <Flex direction="column" justify="center" gap="4" align="center" width="100%">
                        {periods.length === 0 && (
                            <>
                                <ExclamationTriangleIcon color="red" width="25" height="25" />
                                <Text size="1" weight="bold" align="center">An active period is required to start teaching</Text>
                            </>
                        )}
                        <Button size="1" onClick={() => setShowCreateDialog(true)}>Start New Period</Button>
                    </Flex>
                )}
            </Flex>

            <AlertDialog.Root open={showCreateDialog} onOpenChange={setShowCreateDialog}>
                <AlertDialog.Content>
                    <Flex justify="between" align="center" gap="2">
                        <AlertDialog.Title>Create New Period</AlertDialog.Title>
                        <AlertDialog.Cancel>
                            <Cross2Icon />
                        </AlertDialog.Cancel>
                    </Flex>
                    <CreatePeriod
                        onCancel={() => setShowCreateDialog(false)}
                        onSuccess={(period) => {
                            setShowCreateDialog(false);
                            handlePeriodCreated(period);
                        }}
                    />
                </AlertDialog.Content>
            </AlertDialog.Root>

            <Dialog.Root open={showPeriodDialog} onOpenChange={setShowPeriodDialog}>
                <Dialog.Content>
                    <Dialog.Title>Period Details</Dialog.Title>
                    <Dialog.Description><VisuallyHidden>View and manage the details of the selected period.</VisuallyHidden></Dialog.Description>
                    <ViewPeriod
                        period={selectedPeriod}
                        onCancel={() => setShowPeriodDialog(false)}
                        onTeachingPlanCreated={(teachingPlan) => {
                            setShowPeriodDialog(false);
                            // handleTeachingPlanCreated(teachingPlan);
                        }}
                    />
                </Dialog.Content>
            </Dialog.Root>

            <Dialog.Root open={createTeachingPlan.creating} onOpenChange={(bool) => {
                setCreateTeachingPlan({
                    ...createTeachingPlan,
                    creating: bool
                })
            }}>
                <Dialog.Content>
                    <Dialog.Title>{createTeachingPlan.course?.level?.label} | {createTeachingPlan.course?.subject?.name}</Dialog.Title>
                    <Dialog.Description>Create a new teaching plan.</Dialog.Description>
                    <CreateTeachingPlan
                        onCancel={() => setCreateTeachingPlan({ ...createTeachingPlan, creating: false })}
                        onComplete={(teachingPlan) => {
                            setCreateTeachingPlan({ ...createTeachingPlan, creating: false });
                            // handleTeachingPlanCreated(teachingPlan);
                        }}
                        selectedPeriod={createTeachingPlan.period}
                        course={createTeachingPlan.course}
                    />
                </Dialog.Content>
            </Dialog.Root>


        </Box>
    );
};

export default TeacherPeriods;